//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
// import Vue from 'vue'
// import moment from 'moment'
// import DIC from '@/index/dictonary'

export default {
  components: {
  },
  data: function () {
    return {
      form: {
        goodsId: undefined,
        bid: undefined,
        cid: undefined,
        images: [],
        info: undefined,
        price: 0,
        cashBackMoney: 0,
        unit: '',
        model: '',
        name: '',
        size: ''
      },
      brandOptions: [],
      categoryOptions: [],
      publishing: false,
      hasPublished: false,
      rules: {
      },
      loading: false,
      successDialogVisible: false
    }
  },
  computed: {
    toQuery () {
      return this.$route.query
    },
    toName () {
      let r = 'operateGoodsTabs'
      return r
    },
    toTitle () {
      switch (this.$route.query.tab) {
        case 'onSaleGoods':
          return '商城商品'
          break;
        case 'goods':
          return '全部商品'
          break;
      }
    }
  },
  mounted () {
    let p1 = new Promise((resolve, reject) => {
      this.$axios.get('/mtea/store/admin/goods/category/list', { params: {} }).then(res => {
        this.categoryOptions = res
      }).finally(() => {
        resolve()
      })
    })
    let p2 = new Promise((resolve, reject) => {
      this.$axios.get('/mtea/store/admin/goods/brand/list', { params: {} }).then(res => {
        this.brandOptions = res
      }).finally(() => {
        resolve()
      })
    })
    Promise.all([p1, p2]).then(() => {
    })
    let loading = this.$loading({lock: true})
    let data = _.pick(this.$route.params, 'goodsId')
    this.$axios.get('/mtea/store/admin/goods/info', { params: data }).then(res => {
      // console.log('res', res)
      _.extend(this.form, {
        images: res.images ? res.images.split(',') : []
      }, _.pick(res, 'goodsId', 'bid', 'cid', 'info' ,'model', 'name', 'size', 'unit', 'price', 'cashBackMoney'))
      // console.log('form', JSON.stringify(this.form))
    }).finally(() => {
      loading.close()
    })

  },
  methods: {
    handleFormSubmit () {
      this.$refs.form.validate((valid) => {
        // console.log('valid', valid)
        if (valid) {
          let data = _.extend({}, _.omit(this.form, 'images'))
          // console.log('data', data, JSON.stringify(data))
          if (this.form.images.length > 0) {
            data.images = this.form.images.toString()
          }
          this.loading = true
          this.$axios.post('/mtea/store/admin/goods/update', data).then(res => {
            this.successDialogVisible = true
          }).finally(() => {
            this.loading = false
          })
          // this.loading = false
        } else {
          this.$notify.error({
            title: '错误',
            message: '表单校验失败'
          })
        }
      })
    },
    handlePublish () {
      if(this.publishing === false && this.hasPublished === false){
        this.publishing = true
        let url = '/mtea/store/admin/goods/publish'
        let data = _.pick(this.form, 'goodsId')
        this.$axios.post(url, data).then(res => {
          this.$notify.success({
            title: '系统提示',
            message: '操作成功'
          })
          this.hasPublished = true
        }, () => {

        }).finally(() => {
          this.publishing = false
        })
      }
    }
  }
}
